import { render, staticRenderFns } from "./addCurrencyExchange.vue?vue&type=template&id=6be84196&scoped=true&"
import script from "./addCurrencyExchange.vue?vue&type=script&lang=js&"
export * from "./addCurrencyExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be84196",
  null
  
)

export default component.exports